import React from 'react';
import PropTypes from 'prop-types';

class Input extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.value || ''
    };
  }

  componentDidMount() {
    if (this.props.value) {
      this.props.onChange(this.props.value);
    }
  }

  render() {
    let componentProps;

    if (this.props.type === 'number') {
      componentProps = {
        pattern: '[0-9]*',
        min: this.props.min,
        max: this.props.max
      };
    }

    return (
      <input
        className={this.props.className}
        type={this.props.type}
        value={this.state.value}
        placeholder={this.props.placeholder}
        onChange={this.onChange.bind(this)}
        {...componentProps}
      />
    );
  }

  onChange(event) {
    let inputValue = event.target.value;

    if (this.props.type === 'number') {
      inputValue = parseInt(inputValue);

      if ((this.props.max !== undefined && inputValue > this.props.max)
        || (this.props.min !== undefined && inputValue < this.props.min)) {
        this.setState({ value: this.state.value });
        return;
      }

      if (isNaN(inputValue)) { inputValue = ''; }
    }

    this.setState({ value: inputValue }, () => {
      this.props.onChange(inputValue);
    });
  }
}

Input.defaultProps = {
  className: 'input',
  type: 'text',
  value: undefined,
  placeholder: '',
  autoFocus: false,
  min: undefined,
  max: undefined
};

Input.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  autoFocus: PropTypes.bool,
  placeholder: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  onChange: PropTypes.func.isRequired,
};

export default Input;
